module.exports = __webpack_public_path__ + "img/pds_guide_bg.4f3291b9.svg";